//Imports
import React, { useCallback, useEffect } from "react";

//Controls
import { Button, Modal } from "@gpstrackit/gtc-react-controls";

//Components
import { NotificationManager, NotificationContainer } from "Components/Notifications";

//Hooks
import { useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";

//Actions
import { manageDeleteManageInput, reset } from "./redux/slice";

const DeleteManageInput = ({ refresh }) => {
  //Redux
  const dispatch = useDispatch();
  const { open, loading, result, error, deleteInputList } = useSelector(
    (state) => state.manageDeleteManageInputRedux
  );

  //Language
  const { messages } = useIntl();

  //Handlers and utils
  const handleClose = useCallback(() => {
    dispatch(reset());
  }, []);
  const handleDeleteSubmit = useCallback(() => {
    dispatch(manageDeleteManageInput({ items: deleteInputList }));
  }, [deleteInputList]);

  //Effects
  useEffect(() => {
    if (!error) return;
    NotificationManager.error(
      error?.error || messages["errorMessage"],
      messages["error"],
      3000,
      null,
      null,
      "error"
    );
  }, [error]);

  useEffect(() => {
    if (!result) return;
    const messageSuccess =
      !deleteInputList?.length > 0
        ? messages["manage_deletedInput"]
        : messages["manage_deletedInputs"];
    NotificationManager.success(messageSuccess, messages["success"], 3000, null, null, "success");
    refresh();
    dispatch(reset());
  }, [result, deleteInputList]);
  return (
    <Modal
      title={
        !deleteInputList?.length > 0
          ? messages["manage_deleteManageInput_deleteInput"]
          : messages["manage_deleteManageInput_deleteInputs"]
      }
      size="small"
      open={open}
      handleClose={handleClose}
      loading={loading}
      footer={
        <div>
          <Button
            variant="secondary"
            style={{ marginRight: "5px" }}
            onClick={() => handleClose()}
            isDisabled={loading}
          >
            {messages["cancel"]}
          </Button>
          <Button variant="warning" onClick={() => handleDeleteSubmit()} isDisabled={loading}>
            {messages["delete"]}
          </Button>
        </div>
      }
    >
      <div style={{ padding: "10px 25px" }}>
        <p>{messages["manage_deleteManageInput_confirmationMessage"]}</p>
        <ul>
          {deleteInputList.map((input) => (
            <li>{input.title}</li>
          ))}
        </ul>
      </div>
      <NotificationContainer />
    </Modal>
  );
};

export default DeleteManageInput;
